import { createSlice } from '@reduxjs/toolkit'

import { guestUser } from '@/app/services/guestUser'
import { deleteCookie, getCookie, setCookie } from '@/common/helpers/cookie'

const isGuestLoggedInCookie = getCookie('isGuestLoggedIn') ? JSON.parse(getCookie('isGuestLoggedIn')) : false
const guestUserDataCookie = getCookie('guestUserData') ? JSON.parse(getCookie('guestUserData')) : null

const initialState = {
    isGuestLoggedIn: isGuestLoggedInCookie,
    guest: guestUserDataCookie,
    openGuestLoginDialog: null,
}

const guestUserSlice = createSlice({
    name: 'guestUserSlice',
    initialState,
    reducers: {
        unsetGuestUser: (state) => {
            state.guest = null
            state.isGuestLoggedIn = false
            deleteCookie('isGuestLoggedIn')
            deleteCookie('guestUserData')
        },
        setGuestUserLoggedIn: (state) => {
            state.isGuestLoggedIn = true
            setCookie('isGuestLoggedIn', 'true', {
                samesite: 'strict',
                'max-age': 3600,
            })
        },
        setGuestUserData: (state, action) => {
            state.guest = action.payload
            setCookie('guestUserData', JSON.stringify(action.payload), {
                samesite: 'strict',
                'max-age': 3600,
            })
        },
        setOpenGuestLoginDialog: (state, action) => {
            state.openGuestLoginDialog = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(guestUser.endpoints.validateAccessCode.matchFulfilled, () => {
            setGuestUserLoggedIn()
        })
    },
})

export const selectGuestUser = (state) => state.guestUserSlice.guest
export const selectIsGuestLoggedIn = (state) => state.guestUserSlice.isGuestLoggedIn
export const selectOpenGuestLoginDialog = (state) => state.guestUserSlice.openGuestLoginDialog

export const { setGuestUserData, setGuestUserLoggedIn, setOpenGuestLoginDialog, unsetGuestUser } =
    guestUserSlice.actions

export default guestUserSlice.reducer
